<script>
  import { Router, Link, Route } from "svelte-routing";
  import Bulma from "./Bulma.svelte";
  import Cookies from "./Cookies.svelte";
  import Home from "./Home.svelte";
  import Navigation from "./Navigation.svelte";
  import PrivacyPolicy from "./PrivacyPolicy.svelte";
  import TermsOfUse from "./TermsOfUse.svelte";
  import CookiesBar from "./CookiesBar.svelte";

  history.pushState = new Proxy(history.pushState, {
    apply(target, thisArg, argumentsList) {
      const path = argumentsList[2];
      if (path) {
        ga("set", "page", path);
        ga("send", "pageview");
      }
      scrollTo(0, 0);
      Reflect.apply(target, thisArg, argumentsList);
    },
  });

  export let url = "";
</script>

<style>
  main {
    margin-bottom: 60px;
    padding: 0 60px;
    margin-top: 90px;
  }

  @media screen and (max-width: 599.5px) {
    main {
      padding: 0 20px;
    }
  }
</style>

<Router {url}>
  <Navigation />
  <CookiesBar />
  <main>
    <Route path="/privacypolicy" component={PrivacyPolicy} />
    <Route path="/terms" component={TermsOfUse} />
    <Route path="/cookies" component={Cookies} />

    <Route path="/">
      <Home />
    </Route>
  </main>
</Router>
